import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { OrgSelectorService } from 'src/app/core/services/org-selector.service';

import { Card } from '../../../../core/models/card.model';
import { RouteUtils } from '../../../../shared/utils/route/route.util';
import { AppState } from '../../../../store/app.state';
import {
	fetchOrgHubClear,
	fetchOrgHubStart,
} from '../../state/organizations.actions';
import { selectOrghub } from '../../state/organizations.selector';

@Component({
	selector: 'app-org-hub',
	styleUrls: ['./org-hub.component.scss'],
	templateUrl: './org-hub.component.html',
})
export class OrgHubComponent implements OnInit, OnDestroy {
	public card: Card | null = null;

	public cards: Card[] = [];
	private paramsId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly store: Store<AppState>,
		private readonly orgSelection: OrgSelectorService,
	) {}

	get organizationName(): string {
		return this.orgSelection.getOrganizationName() ?? '';
	}

	clickAction(path: string): void {
		switch (path) {
			case '/grupos':
				void this.router.navigateByUrl(`grupos`);
				break;
			case '/apolices':
				void this.router.navigateByUrl(
					`organizacoes/${this.paramsId}${path}?type=saude`,
				);
				break;
			default:
				void this.router.navigateByUrl(`organizacoes/${this.paramsId}${path}`);
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchOrgHubClear());
	}

	ngOnInit(): void {
		this.activatedRoute.paramMap.subscribe((params) => {
			const organizationId = RouteUtils.getRequiredParam({
				param: RouteUtils.params.organizationId,
				params,
			});
			const selectedId = this.orgSelection.getOrganizationId();
			this.paramsId = organizationId;
			if (organizationId !== selectedId) {
				localStorage.setItem('org-id', organizationId);
				localStorage.setItem(
					'org-name',
					this.orgSelection.getOrganizationName(),
				);
				this.orgSelection.setOrganizationId(organizationId);
			}
			this.store
				.select(selectOrghub)
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe((hubs) => {
					if (hubs) {
						const items = hubs.map((hub) => hub);

						if (hubs[0].path === '/cadastro') {
							this.card = items[0];
							this.cards = items.splice(1);
						} else {
							this.cards = items;
						}
					}
				});
			this.store.dispatch(fetchOrgHubStart({ id: organizationId }));
		});
	}
}
